const logglyConfig = require('../loggly.json');

const env = process.env.NODE_ENV;
const apiPort = 44351;
const urlParts = window.location.hostname.split('.');
const baseSiteUrl = env !== 'development' && urlParts != null && urlParts.length > 2
  ? `${ window.location.protocol }//${ urlParts.shift() }-api.${ urlParts.join('.') }`
  : 'http://localhost';

const EnvConfig = {
  env,
  baseApiUrl: env !== 'development'
    ? `${ baseSiteUrl }/api`
    : `https://localhost:${ apiPort }/api`,
  baseSiteUrl: env !== 'development'
    ? baseSiteUrl
    : `${ baseSiteUrl }:8081`,
  cookieConsentName: 'tt_cc',
  eulaCookieName: 'tt_e',
  autentaLinkResendName: 'tt_ar',
  apiEndpoints: {
    authentaLink: '/auth/authentaLink',
    login: '/auth/login',
    logout: '/auth/logout',
    token: '/auth/token',
    forms: '/forms',
    language: '/language',
    config: '/config',
    auth: '/auth',
    validatePin: '/auth/validatePin',
    supportingDocuments: '/supportingdocuments',
    questionnaire: '/questionnaire',
  },
  showAnyError: env !== 'production',
  loggly: {
    enabled: env !== 'development',
    key: logglyConfig.key,
    src: logglyConfig.src
  }
};

export default EnvConfig;
